export const MEDIA_CODE = 4;
export const HTML_CODE = 3;
export const TRANSCRIPTION_CODE = 10;

export const MEDIA_ACCESS_TYPE = {
    NONE: 0,
    AUDIO: 1,
    VIDEO: 2
};

export const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5];
